import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=46774630&scoped=true"
import script from "./CommentHistory.vue?vue&type=script&lang=js"
export * from "./CommentHistory.vue?vue&type=script&lang=js"
import style0 from "./CommentHistory.vue?vue&type=style&index=0&id=46774630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46774630",
  null
  
)

export default component.exports